<template>
  <fragment>
    <!-- CONTACT FORM START -->
    <v-container class="my-5">
      <v-row>
        <v-col cols="12">
          <v-card style="overflow: hidden;" elevation="3">
            <v-card-text class="pa-0">
              <v-row class="ma-0">
                <v-col cols="12" md="5" class="pa-0" :style="cn === 'A52S' ? 'background-color: #ffffff;' : 'background-color: #f4f4f4;'">
                  <v-img :src="`${publicPath}images/samsung/${image}`" class="align-stretch" contain
                         height="100%" aspect-ratio="1.479" position="center center">
                    <div class="d-flex flex-column justify-space-between py-6" style="height: 100%;">
                      <!--<v-icon color="white" x-large v-show="$vuetify.breakpoint.mdAndUp">
                        mdi-email
                      </v-icon>-->
                      <div class="black--text text-center headline align-self-center">
                        {{ $t('ourEmail') }}:<br><a class="body-1 black--text">info@tmx.hu</a>
                      </div>
                      <!--<v-icon color="white" x-large v-show="$vuetify.breakpoint.mdAndUp">
                        mdi-phone
                      </v-icon>-->
                      <div class="black--text text-center headline align-self-center">
                        {{ $t('ourPhoneNumber') }}:<br><a class="body-1 black--text">+36-1/585-8381</a>
                      </div>
                    </div>
                  </v-img>
                </v-col>
                <v-col cols="12" md="7" class="px-10 py-12">
                  <v-form v-model="contactFormIsValid">
                    <v-row>
                      <v-col cols="12" md="6" class="py-2">
                        <v-text-field v-model="customer.lastName"
                                      :label="$t('inputLabels.lastName')"
                                      :rules="inputRules.generalRules"
                                      :hint="$t('inputMessages.requiredField')"
                                      persistent-hint
                                      counter="30"
                                      outlined
                                      required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" class="py-2">
                        <v-text-field v-model="customer.firstName"
                                      :label="$t('inputLabels.firstName')"
                                      :rules="inputRules.generalRules"
                                      :hint="$t('inputMessages.requiredField')"
                                      persistent-hint
                                      counter="30"
                                      outlined
                                      required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" class="py-2">
                        <v-text-field v-model="customer.email"
                                      :label="$t('inputLabels.email')"
                                      :rules="inputRules.emailRules"
                                      :hint="$t('inputMessages.requiredField')"
                                      persistent-hint
                                      counter="30"
                                      outlined
                                      required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" class="py-2">
                        <v-text-field v-model="customer.phone"
                                      :label="$t('inputLabels.phone')"
                                      :rules="inputRules.phoneRules"
                                      :hint="$t('inputMessages.requiredField')"
                                      persistent-hint
                                      prefix="+36-"
                                      v-mask="mask"
                                      outlined
                                      required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" class="body-2" v-if="customer.type === 'CASHBACK'">
                        Kérjük, töltsd fel az előrendelési visszaigazolásodat (Email, szerződés vagy akár egy screenshot), illetve a vásárlásról kapott számládat. Kizárólag az érvényes számla feltöltése esetében válhatsz jogosulttá a kedvezményre.
                      </v-col>
                      <v-col cols="12" v-if="customer.type === 'CASHBACK'">
                        <v-file-input v-model="invoice"
                                      :label="$t('inputLabels.invoice')"
                                      :rules="inputRules.maxFileSizeRequired"
                                      :hint="$t('inputMessages.maxFileSizeRuleRequired')"
                                      persistent-hint
                                      accept="image/*, .pdf, .doc, .docx"
                                      counter
                                      show-size
                                      outlined
                                      ref="fileInput">
                          <template v-slot:selection="{ text }">
                            <v-chip small
                                    label
                                    text-color="white"
                                    color="primary">
                              {{ text }}
                            </v-chip>
                          </template>
                        </v-file-input>
                      </v-col>
                      <v-col cols="12" v-if="customer.type === 'CASHBACK'">
                        <v-file-input v-model="preOrderDoc"
                                      :label="$t('inputLabels.preOrderDoc')"
                                      :hint="$t('inputMessages.maxFileSizeRuleOptional')"
                                      persistent-hint
                                      accept="image/*, .pdf, .doc, .docx"
                                      counter
                                      show-size
                                      outlined
                                      ref="fileInput">
                          <template v-slot:selection="{ text }">
                            <v-chip small
                                    label
                                    text-color="white"
                                    color="primary">
                              {{ text }}
                            </v-chip>
                          </template>
                        </v-file-input>
                      </v-col>
                      <v-col cols="12" class="py-0">
                        <v-checkbox
                          v-model="checkboxes.gdpr"
                          :rules="inputRules.gdprRules"
                          required
                          class="ma-0"
                        >
                          <template slot="label">
                            <span v-show="$i18n.locale === 'hu-HU'" class="body-2">Az <a :href="`${publicPath}doc/Adatvedelmi_Tajekoztato_Honlap_Latogatoknak.pdf`" target="_blank" @click.stop>Adatvédelmi tájékoztatót</a>&nbsp;elolvastam és elfogadom.</span>
                            <span v-show="$i18n.locale === 'en-EN'" class="body-2">I have read and accepted the&nbsp;<a :href="`${publicPath}doc/Adatvedelmi_Tajekoztato_Honlap_Latogatoknak.pdf`" target="_blank" @click.stop>Privacy Policy</a>.</span>
                            <span v-show="$i18n.locale === 'de-DE'" class="body-2">Ich habe die&nbsp;<a :href="`${publicPath}doc/Adatvedelmi_Tajekoztato_Honlap_Latogatoknak.pdf`" target="_blank" @click.stop>Datenschutzbestimmungen</a> gelesen und akzeptiere sie.</span>
                          </template>
                        </v-checkbox>
                      </v-col>
                      <v-col cols="12" class="py-0">
                        <v-checkbox
                          v-model="checkboxes.termsAndCond"
                          :rules="inputRules.gdprRules"
                          required
                          class="ma-0"
                        >
                          <template slot="label">
                            <span v-show="$i18n.locale === 'hu-HU'" class="body-2">
                              Az&nbsp;<a :href="`${publicPath}doc/TMXASZFSamsungTradeInFold3Flip320220513.pdf`" target="_blank" @click.stop>Általános Szerződési Feltételeket</a>&nbsp;elolvastam és elfogadom.
                            </span>
                            <span v-show="$i18n.locale === 'en-EN'" class="body-2">
                              I have read and accepted the&nbsp;<a :href="`${publicPath}doc/TMXASZFSamsungTradeInFold3Flip320220513.pdf`" target="_blank" @click.stop>Terms and Conditions</a>.
                            </span>
                            <span v-show="$i18n.locale === 'de-DE'" class="body-2">
                              Ich habe die&nbsp;<a :href="`${publicPath}doc/TMXASZFSamsungTradeInFold3Flip320220513.pdf`" target="_blank" @click.stop>AGB</a> gelesen und akzeptiere sie.
                            </span>
                          </template>
                        </v-checkbox>
                      </v-col>
                      <v-col cols="12" class="py-0">
                        <v-checkbox
                          v-model="checkboxes.marketing"
                          :rules="inputRules.gdprRules"
                          required
                          class="ma-0"
                        >
                          <template slot="label">
                            <span class="body-2">
                              Hozzájárulok, hogy a TMX Kft. az adataimat a kapcsolatfelvétel céljára kezelje.
                            </span>
                          </template>
                        </v-checkbox>
                      </v-col>
                      <v-col cols="12">
                        <p class="body-2">
                          {{ $t('orderDisclaimer') }}
                        </p>
                      </v-col>
                      <v-col cols="12">
                        <v-row justify="end">
                          <v-btn large text @click="$router.go(-1)" class="mr-4">
                            {{ $t('button.back') }}
                          </v-btn>
                          <v-btn large color="primary" :disabled="!(contactFormIsValid && filesOk)" @click="sendCustomerData">
                            {{ $t('button.send') }}
                          </v-btn>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- CONTACT FORM END -->
    <!-- RESPONSE DIALOGS START -->
    <v-dialog v-model="loadingDialog.visible" width="90%" max-width="440" :persistent="true">
      <loading-dialog v-bind:loading-message="loadingDialog.message" />
    </v-dialog>
    <v-dialog v-model="responseDialog.visible" width="90%" max-width="440" :persistent="true">
      <response-dialog v-bind:response-object="responseDialog.response"
                       v-on:close-dialog="closeResponseDialog"/>
    </v-dialog>
    <!-- RESPONSE DIALOGS END -->
  </fragment>
</template>

<script>
import responseDialog from './responseDialog.vue';
import loadingDialog from './loadingDialog.vue';

export default {
  name: 'PersonalDetailsForm',
  props: {
    formBackgroundImage: String,
    formLogo: String,
    linkTo: String,
  },
  components: {
    responseDialog, loadingDialog,
  },
  beforeMount() {
    this.cn = this.$store.getters.getCampaignName;
    if (this.cn === 'A52S') {
      this.image = 'samsung-a52s-MO-v2.jpg';
    }
    if (this.$store.state.StoreManagement.calcDataId) {
      this.customer.calcDataId = parseInt(this.$store.state.StoreManagement.calcDataId);
    } else {
      // console.log('hiányzik a this.$store.state.StoreManagement.calcDataId');
      this.$router.push({ name: 'home' });
    }
    this.customer.type = this.$route.meta.bbType.toUpperCase();
    this.docReq = this.$route.meta.docReq;
  },
  mounted() {
    //
  },
  data() {
    return {
      cn: null,
      mask: '##-###-####',
      modal: false,
      contactFormIsValid: false,
      docReq: 1,
      loadingDialog: {
        visible: false,
        message: '<div class="display-1"><b>Küldés folyamatban!</b></div><div class="headline mb-4">Kérlek várj türelemmel.</div>',
      },
      responseDialog: {
        visible: false,
        response: {
          error: false,
          message: null,
          status: 201,
        },
      },
      customer: {
        calcDataId: null,
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        type: 'VOUCHER',
        partnerName: this.$store.getters.getPartnerName,
        partnerType: this.$store.getters.getPartnerType,
        campaignName: this.$store.getters.getNewCampaignName,
        campaignId: this.$store.getters.getNewCampaignId,
        value: this.$store.getters.getNewCampaignValue,
      },
      invoice: [],
      preOrderDoc: [],
      checkboxes: {
        gdpr: false,
        termsAndCond: false,
        marketing: false,
      },
      inputRules: {
        generalRules: [v => !!v || this.$t('inputMessages.requiredField')],
        emailRules: [
          v => /.+@.+\..+/.test(v) || this.$t('inputMessages.emailMatch'),
          v => !!v || this.$t('inputMessages.requiredField'),
        ],
        phoneRules: [
          v => /^[0-9\-]*$/.test(v) || this.$t('inputMessages.onlyNumbers'),
          v => !!v || this.$t('inputMessages.requiredField'),
        ],
        gdprRules: [
          v => !!v || this.$t('inputMessages.requiredPrivacy'),
        ],
        termAndCondRules: [
          v => !!v || this.$t('inputMessages.requiredTermsAndCond'),
        ],
        maxFileSizeRequired: [
          v => !v || v.size < 5000000 || this.$t('inputMessages.maxFileSizeRuleRequired'),
        ],
        maxFileSizeOptional: [
          v => this.checkMaxFileSizeOK(v) || this.$t('inputMessages.maxFileSizeRuleOptional'),
        ],
      },
      publicPath: process.env.BASE_URL,
      image: 'mainSliderMOBFoldFlip2022v2.jpg',
    };
  },
  methods: {
    checkMaxFileSizeOK(files) {
      if (files.length > 0) {
        if (files[0].size > 5000000) {
          return false;
        }
      }
      return true;
    },
    async sendCustomerData() {
      //console.log('sendCustomerData start...');
      // console.log('this.customer: ', this.customer);
      this.openLoadingDialog();
      const response = await this.$store.dispatch('sendCustomerData', { customer: this.customer, invoice: this.invoice, preOrderDoc: this.preOrderDoc });
      if (response.status === 201) {
        this.responseDialog.response.message = `<div class="display-1 mb-6"><b>Sikeres beküldés!</b></div><div class="headline mb-4">Kérésed megérkezett hozzánk! A megadott e-mail címre (<b>${this.customer.email}</b>) hamarosan küldjük az előzetes ajánlatot!</div><div>Köszönjük megkeresésed!</div>`;
      } else if(response.status === 405) {
        this.responseDialog.response.message = '<div class="display-1 mb-6"><b>Érvénytelen HTTP hívás</b></div><div class="headline mb-4">A folyamat során váratlan hiba lépett fel!<br>Dolgozunk a hiba elhárításán!</div><div>Köszönjük a türelmed!</div>';
      } else {
        this.responseDialog.response.message = '<div class="display-1 mb-6"><b>Szerver hiba</b></div><div class="headline mb-4">A folyamat során váratlan hiba lépett fel!<br>Dolgozunk a hiba elhárításán!</div><div>Köszönjük a türelmed!</div>';
      }
      this.responseDialog.response.status = response.status;
      this.controlDialogs();
    },
    openLoadingDialog() {
      this.loadingDialog.visible = true;
    },
    closeLoadingDialog() {
      this.loadingDialog.visible = false;
    },
    openResponseDialog() {
      this.responseDialog.visible = true;
    },
    closeResponseDialog() {
      this.responseDialog.visible = false;
      if (this.responseDialog.response.status === 201) {
        if (this.customer.campaignName === 'A52S') {
          this.$router.push({ name: 'estore-voucher-a52-home' });
        } else {
          this.$router.push('/');
        }
      }
    },
    controlDialogs() {
      setTimeout(this.closeLoadingDialog, 3000);
      setTimeout(this.openResponseDialog, 3200);
    },
  },
  watch: {
    //
  },
  computed: {
    filesOk() {
      if (this.customer.type === 'CASHBACK') {
        // mind a két file kötelező
        /* if (this.invoice && this.preOrderDoc) {
          return this.invoice !== [] && this.preOrderDoc !== [];
        } */
        // csak a számla kötelező
        if (this.invoice) {
          return this.invoice !== [];
        }
        return false;
      }
      return true;
    }
  },
};
</script>

<style scoped>

</style>
